import {
  useResponsiveFontSize,
  useResponsiveHeight,
} from '@/components/Util/reactResponsiveDimensions';
import { Linking, Platform, ScrollView, StyleSheet } from 'react-native';
import { Text } from '@/components/Text';
import colors from '@/config/colors';
import { isPatientApp } from '@/config/constants';
import { Links } from '@/config/links';

function UnrevokedConsentText() {
  const responsiveFontSize = useResponsiveFontSize(1);

  const getResponsiveFontSize = (factor) => {
    return responsiveFontSize * factor;
  };
  const responsiveHeight = useResponsiveHeight(100);
  const isFullscreen = Platform.OS !== 'web' && responsiveHeight < 500;

  let responsiveStyles = StyleSheet.create({
    secondConfirmFontStyle: {
      fontSize: isFullscreen
        ? getResponsiveFontSize(2.8)
        : getResponsiveFontSize(2.5),
      margin: getResponsiveFontSize(1),
    },
    hierWordStyle: {
      fontSize: isFullscreen
        ? getResponsiveFontSize(2.8)
        : getResponsiveFontSize(2.5),
      color: colors.darkPurpleBlue,
      top: useResponsiveFontSize(0.4),
      marginHorizontal: getResponsiveFontSize(0.3),
      fontWeight: '700',
    },
  });

  // Define the text content based on whether the app is in patient mode
  const contentText = isPatientApp ? (
    <>
      Die Bereitstellung der App ist ohne diese Einwilligung nicht weiter
      möglich. Wenn Sie Ihre Einwilligung widerrufen, können Sie die App
      „neolexon Aphasie“ nicht länger verwenden und alle Ihre Daten werden mit
      sofortiger Wirkung unwiderruflich gelöscht. Falls Sie dies wünschen,
      können Sie vor der Löschung Ihre Daten{' '}
      <Text
        style={responsiveStyles.hierWordStyle}
        onPress={() => Linking.openURL(Links.export.href)}
      >
        hier
      </Text>{' '}
      unter Mein Account exportieren und abspeichern.
    </>
  ) : (
    <>
      Die Bereitstellung der App ist ohne diese Einwilligung nicht weiter
      möglich. Wenn Sie Ihre Einwilligung widerrufen, können Sie neolexon nicht
      länger verwenden und alle Ihre Daten werden mit sofortiger Wirkung
      unwiderruflich gelöscht.
    </>
  );

  return (
    <ScrollView>
      <Text style={responsiveStyles.secondConfirmFontStyle}>{contentText}</Text>
    </ScrollView>
  );
}

export default UnrevokedConsentText;
